import React from 'react'
import { IssuingAnalystAccessModify } from './issuingAnalystAccessModify'

export const IssuingAnalystUserAccessModify = () => {
  return (
    <IssuingAnalystAccessModify />
  )
}
